export default [
    { id: 'carouselgroundwater1', title: 'Temperatura del agua', src: 't_agua.png', src_hover: 't_agua_h.png', pdf: '' },
    { id: 'carouselgroundwater2', title: 'Carga hidrostática', src: 'c_hidrostatica.png', src_hover: 'c_hidrostatica_h.png', pdf: '' }
]